import React, { useEffect, useRef, useCallback } from "react";
import { variants, styleJson, mapStyles } from "./utils";
import pin from "./assets/Pin.png";
import centerPin from "./assets/PinPinkBig.png";
import { AnimatePresence } from "framer-motion";
import moment from "moment";
import { StyledMap } from "./styles";

const GoogleMaps = ({ clicked, info }) => {
  console.log(clicked, info);
  // refs
  const googleMapRef = React.createRef();
  const googleMap = useRef(null);
  const infoWindow = useRef(null);

  // helper functions
  const createGoogleMap = useCallback(
    () =>
      new window.google.maps.Map(googleMapRef.current, {
        zoom: 11,
        tilt: 0,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: false,
        mapTypeId: "roadmap",
        mapTypeControlOptions: {
          mapTypeIds: [
            "roadmap",
            "satellite",
            "hybrid",
            "terrain",
            "styled_map",
          ],
        },
        center: {
          lat: info.lat,
          lng: info.lng,
        },
      }),
    // eslint-disable-next-line
    [googleMapRef]
  );
  const createStyles = useCallback(() => {
    console.log("calls");
    let styledMapType = new window.google.maps.StyledMapType(styleJson, {
      name: "Styled Map",
    });

    googleMap.current.mapTypes.set("styled_map", styledMapType);
    googleMap.current.setMapTypeId("styled_map");
  }, []);

  const createMarker = useCallback((curr) => {
    const marker = new window.google.maps.Marker({
      position: { lat: +curr.lat, lng: +curr.lng },
      map: googleMap.current,
      icon: pin,
    });
    window.google.maps.event.addListener(marker, "click", () => {
      infoWindow.current.setContent(
        `<div style="text-align: center;"><div>Panel Type: ${
          curr.panel
        }</div><div>System Size: ${curr.systemsize} kW</div><div>${
          curr.city
        }, ${curr.state}</div>
            <div>
            ${
              curr.Installation_Complete
                ? `Install Date: ${moment(curr.Installation_Complete).format(
                    "MM/DD/YYYY"
                  )}`
                : ""
            }
            </div>
        </div>`
      );
      infoWindow.current.open(googleMap.current, marker);
    });
  }, []);

  const createCenterMarker = useCallback((curr) => {
    const marker = new window.google.maps.Marker({
      position: { lat: +curr.lat, lng: +curr.lng },
      map: googleMap.current,
      icon: centerPin,
      animation: window.google.maps.Animation.DROP,
    });
    window.google.maps.event.addListener(marker, "click", () => {
      infoWindow.current.setContent(`<div>Your Home!</div>`);
      infoWindow.current.open(googleMap.current, marker);
    });
  }, []);
  // useEffect Hooks
  useEffect(() => {
    console.log("calls");
    googleMap.current = createGoogleMap();
    createStyles();
    googleMap.current.addListener("zoom_changed", () => {
      if (googleMap.current.zoom > 17) {
        googleMap.current.setMapTypeId("satellite");
      } else {
        googleMap.current.setMapTypeId("styled_map");
      }
    });
    infoWindow.current = new window.google.maps.InfoWindow();
    googleMap.current.addListener("click", function () {
      if (infoWindow.current) infoWindow.current.close();
    });
    for (let i = 0; i < info.allData.length; i++) {
      setTimeout(() => createMarker(info.allData[i]), i * 5);
    }
    const mount = async () => {
      const { lat, lng } = info;
      googleMap.current.setCenter({ lat, lng });
      createCenterMarker({ lat, lng });
    };
    mount();
    // eslint-disable-next-line
  }, [createGoogleMap, createMarker]);

  return (
    <AnimatePresence>
      <StyledMap
        style={{ border: "2px solid white" }}
        variants={variants}
        animate={!clicked ? "closed" : "open"}
      >
        <div id="google-map" ref={googleMapRef} style={mapStyles} />
      </StyledMap>
    </AnimatePresence>
  );
};

export default GoogleMaps;
